import { Box, Heading, HStack, Text, VStack } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { Link } from 'react-router';

type Props = {
  title?: string;
  subtitle?: string;
  tertiaryTitle?: string;
  children: ReactNode;
  slotRight?: ReactNode;
  href?: string;
  linkText?: string;
};

type LayoutProps =
  | {
      header: ReactNode;
      title?: never;
      subtitle?: never;
      tertiaryTitle?: never;
      href?: never;
      linkText?: never;
      slotRight?: never;
      children: ReactNode;
    }
  | (Props & {
      header?: never;
    });

export const PageLayout = ({
  title,
  subtitle,
  tertiaryTitle,
  children,
  slotRight,
  href,
  linkText,
  header,
}: LayoutProps) => {
  return (
    <VStack gap={6} alignItems="flex-start" w="full">
      {header === undefined ? (
        <PageHeader
          title={title || ''}
          subtitle={subtitle}
          tertiaryTitle={tertiaryTitle}
          slotRight={slotRight}
          href={href}
          linkText={linkText}
        />
      ) : (
        header
      )}
      {children}
    </VStack>
  );
};

export const PageHeader = ({ title, subtitle, tertiaryTitle, slotRight, href, linkText }: Omit<Props, 'children'>) => {
  return (
    <HStack justifyContent="space-between" w="full">
      <VStack align="flex-start" gap={[1, 1, 2]} maxWidth="650px">
        <Heading
          fontSize={['3xl', '3xl', '4xl']}
          textAlign="left"
          lineHeight="120%"
          letterSpacing="-0.8px"
          fontWeight="700"
        >
          {title}
        </Heading>
        {subtitle && (
          <Text color="fg" fontWeight="500" fontSize={'xl'} lineHeight="140%">
            {subtitle}
          </Text>
        )}
        {tertiaryTitle && (
          <Text
            color="text.secondary"
            fontWeight="500"
            fontSize={'xl'}
            lineHeight="140%"
            fontFamily="Lufga, sans-serif"
          >
            {tertiaryTitle}
          </Text>
        )}
      </VStack>
      {href && (
        <Link to={href}>
          <Text color="colorPalette.600" _hover={{ color: 'colorPalette.600/60' }} fontSize="sm" pb={3}>
            {linkText}
          </Text>
        </Link>
      )}
      {slotRight && <Box hideBelow="lg">{slotRight}</Box>}
    </HStack>
  );
};
